import { useEffect, useMemo, useState } from "react";

import { useSession, useSignIn } from "../../Recoil/Session/Session";
import { useToastAlert } from "@webtoontoday/toast";
import { logBehavior } from "../../Data/Behavior";

import Logout from "./Components/Logout";
import Login from "./Components/Login";
import OneColumnFullpageDialog from "../../Components/OneColumnFullpageDialog";

import { BranchFunction, fn } from "../../Functions";


type pages = (
    'login'|
    'logout'|
    'somethingwrong'
);


const LoginHome = ({path, query}: {path: string, query: string}) => {
    
    const { toastAlert } = useToastAlert();
    const {session, sessionRefresh} = useSession();
    const { EmailTokenSignin } = useSignIn();

    const params = new URLSearchParams(query);
    const paramsEmail = params.get('email');
    const redirectTo = params.get('redirectTo') || '/home';
    const token = params.get('token') ?? undefined;
    const isInvited = params.get('invite') === 'true';

    useEffect(()=>{
        if (session.memberState === 'regular') {
            if (localStorage.getItem('firstSignUp') === 'true'){
                localStorage.removeItem('firstSignUp');
                fn.goto('/');
            } else{
                fn.replaceWith(redirectTo);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[session])

    useEffect(()=>{

        let timer = setTimeout(()=>{
            (async()=>{
                const url =  new URL(window.location.href)
                const email = url.searchParams.get('email');
                const token = url.searchParams.get('token');
                if (email && token){
                    

                    if (toastAlert === global.alert){
                        setTimeout(()=>{
                            toastAlert("자동 로그인 중입니다.",2000);
                        },100);
                    }else{
                        toastAlert("자동 로그인 중입니다.",2000);
                    }
                    let res = await EmailTokenSignin(email, token);
                    
                    if (res){
                        logBehavior('login(success)',{});
                        toastAlert("자동 로그인이 성공했습니다.",2000);

                        if (url.searchParams.get('redirectTo')) {
                            fn.goto(url.searchParams.get('redirectTo'));
                        }else {
                            fn.goto('/')
                        }
                        sessionRefresh();
                    }else{
                        toastAlert("인증에 실패했습니다. 다시 확인해주세요.")
                    };
                };

                if (email) {
                    setEmail(email);
                };
            })();
        },200)

        return ()=>{
            clearTimeout(timer);
        }

    },[EmailTokenSignin, sessionRefresh, toastAlert])

    const currentBranch = useMemo(() => BranchFunction<pages, string>(
        path,[
            {
                validator: (path) => /^\/login/i.test(path),
                defaultValue: 'login',
            },
            {
                validator: (path) => /^\/logout/i.test(path),
                defaultValue: 'logout',
            }
        ],
        'somethingwrong'
    ), [path]);

    /* email */
    const [email, setEmail] = useState<string>(paramsEmail || '');
    const [otp, setOtp] = useState('');


    if (currentBranch === 'login'){
        return  <Login {...{
            email, setEmail, otp, setOtp, redirectTo, token, isInvited
        }}/>;
    } else if (currentBranch === 'logout'){
        return <Logout/>;
    };

    return (<OneColumnFullpageDialog>
        {"뭔가 문제가 있습니다!"}
    </OneColumnFullpageDialog>);
};

export default LoginHome ;